import _color from '@/assets/utils/color.js';
<template>
  <div
    class="mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."
  >
    <vx-card>
      <div class="vx-row mt-2">
        <div class="vx-col mt-3" style="width: 200px; text-align: right">
          <span>Number</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <vs-input
            class="w-3/5"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="number"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2 mt-6">
        <div class="column is-narrow" style="width: 200px; text-align: right">
          <span>To DTO</span>
        </div>
        <div style="width: 450px">
          <vx-input-group>
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="tcompanyGroupsCode"
              :readonly="true"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  color="#5b3cc4"
                  type="filled"
                  icon="search"
                  @click="searchBuss"
                  >ดึงข้อมูล DTO</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Remark</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="remark"
          />
        </div>
      </div>

      <div class="vx-row mt-8">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="onSubmit">Submit</vs-button>
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>

    <vs-popup fullscreen title="Business Partner" :active.sync="popupActive1">
      <bussgrid v-if="popupActive1" @recsel2="recsel2"></bussgrid>
    </vs-popup>
  </div>
</template>

<script>
// import { required, integer } from "vuelidate/lib/validators";
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";
import bussgrid from "./bussgrid.vue";

export default {
  data() {
    return {
      number: "",
      businessPartnersCode: "",
      tcompanyGroupsCode: "",
      customers: [],
      paymentTerm: 0,
      remark: "",
      postState: "",
      readonly: false,
      popupActive1: false,
    };
  },
  validations: {},
  components: {
    bussgrid,
  },
  props: ["acstate", "recid"],
  methods: {
    clsd: function () {
      let vm = this;

      this.remark = "";
      vm.$emit("grid");
    },
    searchBuss() {
      this.popupActive1 = true;
    },
    async recsel2(val) {
      this.popupActive1 = false;

      // console.log(val);
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response = await axios.get(
        `${BASE_API_URL}/inbound-svc/businesspartners/${val}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response.data.message,
        });
      } else {
        this.tcompanyGroupsCode = response.data.companyGroupsCode;
      }
    },
    async onSubmit() {
      // alert("Hi");
      let vm = this;

      const formData = {
        acstate: this.acstate,
        companyGroupsCode: this.companyGroupsCode,
        tcompanyGroupsCode: this.tcompanyGroupsCode,
        number: this.recid,
        remark: this.remark,
        editor: String(this.userid),
      };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/moves/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
            // vm.clsd();
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }

      // vm.$emit("grid");
      // vm.clsd();
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        try {
          // const response = await axios.get(`${BASE_API_URL}/auth/profile`, {
          //   headers: { Authorization: "Bearer " + token.accessToken }
          // });

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          // this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
          // console.log(decoded);
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
  },
  async created() {
    // console.log(this.recid);
    // console.log("create");
    this.checkProfiles();

    if (this.recid != "0") {
      // alert("Edit");
      try {
        this.readonly = true;
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const response = await axios.get(
          `${BASE_API_URL}/inbound-svc/moves/${this.recid}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.number = response.data.number;
          this.tcompanyGroupsCode = response.data.tcompanyGroupsCode,
          this.remark = response.data.remark;
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
